<template>
  <div class="pages">
    <div class="pagesContent">
      <top-nav :leftData='leftData' :activeNav='$route.params.pathId'></top-nav>
      <div class="bottomeContent">
        <div class="title">
          <div class="name">{{contentTitle}}</div>
          <div class="engName">{{englishName}}</div>
        </div>
        <div class="compContent">
          <aboutBrief v-if="$route.params.pathId === 'aboutBrief'"></aboutBrief>
          <aboutCEO v-if="$route.params.pathId === 'aboutCEO'"></aboutCEO>
          <aboutIdea v-if="$route.params.pathId === 'aboutIdea'"></aboutIdea>
          <aboutIntro v-if="$route.params.pathId === 'aboutIntro'"></aboutIntro>
          <aboutRange v-if="$route.params.pathId === 'aboutRange'"></aboutRange>
          <aboutCooper v-if="$route.params.pathId === 'aboutCooper'"></aboutCooper>
          <aboutNews v-if="$route.params.pathId === 'aboutNews'"></aboutNews>
          <aboutDuty v-if="$route.params.pathId === 'aboutDuty'"></aboutDuty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import topNav from '@/components/topNav'
  import aboutBrief from '@/components/aboutBrief'
  import aboutCEO from '@/components/aboutCEO'
  import aboutIdea from '@/components/aboutIdea'
  import aboutIntro from '@/components/aboutIntro'
  import aboutRange from '@/components/aboutRange'
  import aboutCooper from '@/components/aboutCooper'
  import aboutNews from '@/components/aboutNews'
  import aboutDuty from '@/components/aboutDuty'
  export default {
    name: 'about',
    components: {
      topNav,
      aboutBrief,
      aboutCEO,
      aboutIdea,
      aboutIntro,
      aboutRange,
      aboutCooper,
      aboutNews,
      aboutDuty
    },
    data() {
      return {
        leftData: {
          title: '公司简介',
          navs: [{
              name: 'aboutBrief',
              text: '公司简介',
              fatherPath: 'about',
              english: 'COMPANY PROFILE',
              subBa: require('../assets/images/subBanner1.png')
            },
            // {
            //   name: 'aboutCEO',
            //   text: '总裁寄语',
            //   fatherPath: 'about',
            //   english: 'PRESIDENT OF MESSAGE'
            // },
            {
              name: 'aboutIdea',
              text: '经营理念',
              fatherPath: 'about',
              english: 'MANAGEMENT IDEA',
              subBa: require('../assets/images/subBanner2.png')
            },
            {
              name: 'aboutIntro',
              text: '股东介绍',
              fatherPath: 'about',
              english: 'SHAREHOLDERS TO INTRODUCE',
              subBa: require('../assets/images/subBanner3.png')
            },
            {
              name: 'aboutRange',
              text: '营业范围',
              fatherPath: 'about',
              english: 'THE BUSINESS SCOPE',
              subBa: require('../assets/images/subBanner4.png')
            },
            {
              name: 'aboutCooper',
              text: '合作企业和平台',
              fatherPath: 'about',
              english: 'COOPERATIVE ENTERPRISES AND PLATFORMS',
              subBa: require('../assets/images/subBanner5.png')
            },
            {
              name: 'aboutNews',
              text: '新闻动态',
              fatherPath: 'about',
              english: 'NEWS AND TRENDS',
              subBa: require('../assets/images/subBanner6.png')
            },
            {
              name: 'aboutDuty',
              text: '社会责任',
              fatherPath: 'about',
              english: 'SOCIAL RESPONSIBILITY',
              subBa: require('../assets/images/subBanner7.png')
            }
          ]
        }
      }
    },
    computed: {
      contentTitle() {
        return this.leftData.navs.find(item => item.name === this.$route.params.pathId).text
      },
      englishName() {
        return this.leftData.navs.find(item => item.name === this.$route.params.pathId).english
      }
    },
    created() {},
    mounted() {},
    methods: {

    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .compContent {}
</style>